import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authAPI from "../../../services/authApi";
import { fetchAuthMe } from "../../../store/authSlice";
import { Button, Field, Input, useToast } from "../../ui";
import { OwnerPage, OwnerPanel } from "./OwnerPage";
import s from "./ownerCabinet.module.css";

export default function OwnerProfile() {
  const dispatch = useDispatch();
  const toast = useToast();
  const { profile } = useSelector((state) => state.auth);
  const [form, setForm] = useState({ full_name: "", phone: "" });
  const [pwd, setPwd] = useState({ current: "", next: "" });
  const [saving, setSaving] = useState(false);
  const [pwdSaving, setPwdSaving] = useState(false);

  useEffect(() => {
    setForm({
      full_name: profile?.full_name || "",
      phone: profile?.phone || "",
    });
  }, [profile]);

  const saveProfile = async () => {
    setSaving(true);
    try {
      await authAPI.updateMyAccount({
        full_name: form.full_name,
        phone: form.phone,
      });
      await dispatch(fetchAuthMe());
      toast.success("Сохранено");
    } catch (e) {
      toast.error(e.response?.data?.error || "Ошибка сохранения");
    } finally {
      setSaving(false);
    }
  };

  const savePassword = async () => {
    if (!pwd.current || !pwd.next) {
      toast.error("Заполните оба поля пароля");
      return;
    }
    setPwdSaving(true);
    try {
      await authAPI.changePassword(pwd.current, pwd.next);
      setPwd({ current: "", next: "" });
      toast.success("Пароль изменён");
    } catch (e) {
      toast.error(e.response?.data?.error || "Ошибка");
    } finally {
      setPwdSaving(false);
    }
  };

  return (
    <OwnerPage
      title="Профиль"
      subtitle={profile?.email || "Email не указан"}
    >
      <OwnerPanel title="Личные данные">
        <div className={s.formStack}>
          <Field label="ФИО">
            <Input
              value={form.full_name}
              onChange={(e) =>
                setForm((f) => ({ ...f, full_name: e.target.value }))
              }
            />
          </Field>
          <Field label="Телефон">
            <Input
              value={form.phone}
              onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
            />
          </Field>
          <Field label="Email">
            <Input value={profile?.email || ""} readOnly />
          </Field>
          <Button type="button" disabled={saving} onClick={saveProfile}>
            {saving ? "Сохранение…" : "Сохранить"}
          </Button>
        </div>
      </OwnerPanel>

      <OwnerPanel title="Смена пароля">
        <div className={s.formStack}>
          <Field label="Текущий пароль">
            <Input
              type="password"
              value={pwd.current}
              onChange={(e) => setPwd((p) => ({ ...p, current: e.target.value }))}
              autoComplete="current-password"
            />
          </Field>
          <Field label="Новый пароль">
            <Input
              type="password"
              value={pwd.next}
              onChange={(e) => setPwd((p) => ({ ...p, next: e.target.value }))}
              autoComplete="new-password"
            />
          </Field>
          <Button
            type="button"
            variant="secondary"
            disabled={pwdSaving}
            onClick={savePassword}
          >
            {pwdSaving ? "Сохранение…" : "Изменить пароль"}
          </Button>
        </div>
      </OwnerPanel>
    </OwnerPage>
  );
}
